<!-- ============================ -->
<!-- Simplify Employee Uniform section start here... -->
<!-- ============================ -->
<section class="transforming taylorsec">
  <div class="max-width-container rounded-5">
    <div class="transback container pt-5" style="min-height: auto;">
      <div class="row align-items-center gy-5 justify-content-center justify-content-lg-between">
        <div class="col-12 col-xl-6">
          <div class="items">
            <h2 class="lh-sm">
              Set uniform access by
              <br class="d-none d-lg-block" />
              role, site, or project
            </h2>
            <p class="text-secondary my-4">Create Groups in SUMS to organise your workforce and apply the right uniform
              catalogue and rules automatically, all from one account.
            </p>
            <div class="button-grps">
              <button class="btn btn-primary" routerLink="/contactus">
                See Groups in action
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="imgboxinfo">
            <div class="plsec">
              <div class="departde">
                <div class="plusbbtn">
                  <img src="../../../../assets/images/medicalplus.svg" alt="" />
                </div>
                <div class="clientinfo">
                  <div class="img-box">
                    <img src="../../../../assets/images/ssumt1.png" alt="" />
                  </div>
                  <div class="clname">Peter Wood</div>
                  <div class="clposition">Procurement Manager at Med-Tech</div>
                </div>
              </div>
              <div class="departinnerbox">
                <div class="nmesw">
                  <div class="img-box">
                    <img src="../../../../assets/images/denam.png" alt="" />
                  </div>
                  <div class="innames">
                    <div class="nmde">Peter Wood</div>
                    <div class="nmpro">Procurement Manager at Med-Tech</div>
                  </div>
                </div>
              </div>
              <div class="poabsolutebox">
                <div class="otherimg imgposa">
                  <div class="img-box">
                    <img src="../../../../assets/images/ssumt2.png" alt="" />
                  </div>
                  <span>Engineering</span>
                </div>
                <div class="otherimg imgposb">
                  <div class="img-box">
                    <img src="../../../../assets/images/ssumt4.png" alt="" />
                  </div>
                  <span>Management</span>
                </div>
                <div class="otherimg imgposc">
                  <div class="img-box">
                    <img src="../../../../assets/images/ssumt3.png" alt="" />
                  </div>
                  <span>Drivers</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ============================ -->
<!-- Simplify Employee Uniform section end here... -->
<!-- ============================ -->

<!-- ============================ -->
<!-- Why Use Groups section start here... -->
<!-- ============================ -->
<section class="solslid group-slide">
  <div class="max-width-container">
    <div class="container mb-5 pb-5">
      <h2>Why Use Groups?</h2>
      <p>Set role-based access, entitlements, and pricing rules once, then apply them automatically to every user in
        that Group.</p>
    </div>
    <div class="group-features-tab" #groupSection>
      <div class="row align-items-center justify-content-center justify-content-lg-between">
        <div class="col-12 col-lg-6 col-xl-5">
          <div class="" id="pills-tab" role="tablist">

            <div role="presentation" *ngFor="let card of cards; let i = index">
              <div class="edit-card card shadow-none" [class.active]="card.key === activeKey" [attr.id]="card.tabId"
                data-bs-toggle="pill" [attr.data-bs-target]="card.target" role="tab" (click)="onCardClick(card.key)">
                <ng-container [ngSwitch]="card.key">

                  <div class="card-body p-5" *ngSwitchCase="'product'">
                    <span class="d-inline-flex align-items-center justify-content-center mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <path d="M12 18V4H36V18" fill="url(#paint0_radial_1086_570383)" fill-opacity="0.5" />
                        <path
                          d="M12 36H8C6.93913 36 5.92172 35.5786 5.17157 34.8284C4.42143 34.0783 4 33.0609 4 32V22C4 20.9391 4.42143 19.9217 5.17157 19.1716C5.92172 18.4214 6.93913 18 8 18H40C41.0609 18 42.0783 18.4214 42.8284 19.1716C43.5786 19.9217 44 20.9391 44 22V32C44 33.0609 43.5786 34.0783 42.8284 34.8284C42.0783 35.5786 41.0609 36 40 36H36"
                          fill="url(#paint1_radial_1086_570383)" fill-opacity="0.5" />
                        <path d="M36 28H12V44H36V28Z" fill="url(#paint2_radial_1086_570383)" fill-opacity="0.5" />
                        <path
                          d="M12 18V4H36V18M12 36H8C6.93913 36 5.92172 35.5786 5.17157 34.8284C4.42143 34.0783 4 33.0609 4 32V22C4 20.9391 4.42143 19.9217 5.17157 19.1716C5.92172 18.4214 6.93913 18 8 18H40C41.0609 18 42.0783 18.4214 42.8284 19.1716C43.5786 19.9217 44 20.9391 44 22V32C44 33.0609 43.5786 34.0783 42.8284 34.8284C42.0783 35.5786 41.0609 36 40 36H36M12 28H36V44H12V28Z"
                          stroke="#06273B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <defs>
                          <radialGradient id="paint0_radial_1086_570383" cx="0" cy="0" r="1"
                            gradientUnits="userSpaceOnUse" gradientTransform="translate(24 6) rotate(90) scale(29)">
                            <stop stop-color="#8BD6EF" />
                            <stop offset="1" stop-color="#8BD6EF" stop-opacity="0" />
                          </radialGradient>
                          <radialGradient id="paint1_radial_1086_570383" cx="0" cy="0" r="1"
                            gradientUnits="userSpaceOnUse" gradientTransform="translate(24 6) rotate(90) scale(29)">
                            <stop stop-color="#8BD6EF" />
                            <stop offset="1" stop-color="#8BD6EF" stop-opacity="0" />
                          </radialGradient>
                          <radialGradient id="paint2_radial_1086_570383" cx="0" cy="0" r="1"
                            gradientUnits="userSpaceOnUse" gradientTransform="translate(24 6) rotate(90) scale(29)">
                            <stop stop-color="#8BD6EF" />
                            <stop offset="1" stop-color="#8BD6EF" stop-opacity="0" />
                          </radialGradient>
                        </defs>
                      </svg>
                    </span>
                    <h4 class="mb-4 mt-1">Tailored product visibility</h4>
                    <p>Show each Group only the uniforms they’re approved to order.
                      Restrict access to relevant collections by role, site, or project.
                    </p>
                  </div>

                  <div class="card-body p-5" *ngSwitchCase="'allocation'">
                    <span class="d-inline-flex align-items-center justify-content-center mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <rect width="48" height="48" fill="white" />
                        <path
                          d="M37.6591 28.5084C38.2553 27.8624 38.5533 27.5396 38.8701 27.3512C39.6343 26.8966 40.5753 26.8824 41.3523 27.3138C41.6745 27.4926 41.9817 27.8064 42.5961 28.4342C43.2107 29.062 43.5179 29.3758 43.6929 29.7048C44.1151 30.4984 44.1013 31.4598 43.6563 32.2406C43.4719 32.5642 43.1559 32.8686 42.5235 33.4776L35.0007 40.7234C33.8025 41.8774 33.2033 42.4546 32.4545 42.747C31.7057 43.0394 30.8827 43.018 29.2363 42.9748L29.0125 42.969C28.5113 42.956 28.2607 42.9494 28.1149 42.784C27.9693 42.6188 27.9891 42.3634 28.0289 41.853L28.0505 41.5758C28.1625 40.1388 28.2185 39.4204 28.4991 38.7746C28.7797 38.1288 29.2637 37.6044 30.2317 36.5556L37.6591 28.5084Z"
                          stroke="black" stroke-width="1.5" stroke-linejoin="round" />
                        <path
                          d="M44 21V19.435C44 15.5557 44 13.6161 42.8284 12.411C41.6568 11.2059 39.7712 11.2059 36 11.2059H31.8428C30.008 11.2059 29.9928 11.2023 28.343 10.3767L21.6798 7.04228C18.8977 5.65008 17.5066 4.95398 16.0248 5.00236C14.5429 5.05074 13.1975 5.83616 10.5069 7.40702L8.05116 8.84074C6.07478 9.99458 5.08658 10.5715 4.54328 11.5313C4 12.4911 4 13.6599 4 15.9975V32.4314C4 35.5028 4 37.0386 4.68452 37.8934C5.14002 38.462 5.77832 38.8444 6.484 38.9712C7.54452 39.1616 8.84296 38.4036 11.4397 36.8874C13.2031 35.858 14.9002 34.7888 17.0097 35.0788C18.7774 35.3216 20.42 36.437 22 37.2276"
                          fill="url(#paint0_linear_1086_570470)" />
                        <path
                          d="M44 21V19.435C44 15.5557 44 13.6161 42.8284 12.411C41.6568 11.2059 39.7712 11.2059 36 11.2059H31.8428C30.008 11.2059 29.9928 11.2023 28.343 10.3767L21.6798 7.04228C18.8977 5.65008 17.5066 4.95398 16.0248 5.00236C14.5429 5.05074 13.1975 5.83616 10.5069 7.40702L8.05116 8.84074C6.07478 9.99458 5.08658 10.5715 4.54328 11.5313C4 12.4911 4 13.6599 4 15.9975V32.4314C4 35.5028 4 37.0386 4.68452 37.8934C5.14002 38.462 5.77832 38.8444 6.484 38.9712C7.54452 39.1616 8.84296 38.4036 11.4397 36.8874C13.2031 35.858 14.9002 34.7888 17.0097 35.0788C18.7774 35.3216 20.42 36.437 22 37.2276"
                          stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M16 5V35" stroke="black" stroke-width="1.5" stroke-linejoin="round" />
                        <path d="M30 11V27" stroke="black" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <defs>
                          <linearGradient id="paint0_linear_1086_570470" x1="24" y1="5" x2="24" y2="39.0001"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#CEEEF8" />
                            <stop offset="1" stop-color="white" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </span>
                    <h4 class="mb-4 mt-1">Seamless allocation</h4>
                    <p>
                      Set uniform entitlements at the Group level, then automate new starter setup.
                      Apply the same allowances to every new user added to the Group.
                    </p>
                  </div>

                  <div class="card-body p-5" *ngSwitchCase="'price'">
                    <span class="d-inline-flex align-items-center justify-content-center mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <g clip-path="url(#clip0_1086_570561)">
                          <path
                            d="M12.5 21C17.1944 21 21.0001 17.1944 21.0001 12.5C21.0001 7.80558 17.1944 4 12.5 4C7.80558 4 4 7.80558 4 12.5C4 17.1944 7.80558 21 12.5 21Z"
                            stroke="black" stroke-width="1.5" />
                          <path
                            d="M35.5 44C40.1944 44 44 40.1944 44 35.5C44 30.8056 40.1944 27 35.5 27C30.8056 27 27 30.8056 27 35.5C27 40.1944 30.8056 44 35.5 44Z"
                            stroke="black" stroke-width="1.5" />
                          <path
                            d="M12.5 44C17.1944 44 21.0001 40.1944 21.0001 35.5C21.0001 30.8056 17.1944 27 12.5 27C7.80558 27 4 30.8056 4 35.5C4 40.1944 7.80558 44 12.5 44Z"
                            stroke="black" stroke-width="1.5" />
                          <path
                            d="M41.7357 4.87867L43.1205 6.26341C44.2921 7.43497 44.2921 9.33447 43.1205 10.5061L35.8657 17.8974C35.2951 18.4681 34.5651 18.8528 33.7717 19.001L29.2753 19.9771C28.5655 20.1311 27.9333 19.5008 28.0853 18.7905L29.0425 14.3199C29.1905 13.5265 29.5753 12.7965 30.1459 12.2258L37.4931 4.87867C38.6647 3.70711 40.5643 3.70711 41.7357 4.87867Z"
                            stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M13.8 1.9V-10H34.2V1.9" fill="url(#paint0_radial_1086_570561)" fill-opacity="0.5" />
                          <path
                            d="M13.8 17.2H10.4C9.49826 17.2 8.63346 16.8418 7.99584 16.2042C7.35821 15.5665 7 14.7017 7 13.8V5.3C7 4.39826 7.35821 3.53346 7.99584 2.89584C8.63346 2.25821 9.49826 1.9 10.4 1.9H37.6C38.5017 1.9 39.3665 2.25821 40.0042 2.89584C40.6418 3.53346 41 4.39826 41 5.3V13.8C41 14.7017 40.6418 15.5665 40.0042 16.2042C39.3665 16.8418 38.5017 17.2 37.6 17.2H34.2"
                            fill="url(#paint1_radial_1086_570561)" fill-opacity="0.5" />
                          <path d="M34.2 10.4H13.8V24H34.2V10.4Z" fill="url(#paint2_radial_1086_570561)"
                            fill-opacity="0.5" />
                        </g>
                        <defs>
                          <radialGradient id="paint0_radial_1086_570561" cx="0" cy="0" r="1"
                            gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(24 -8.3) rotate(90) scale(24.65)">
                            <stop stop-color="#8BD6EF" />
                            <stop offset="1" stop-color="#8BD6EF" stop-opacity="0" />
                          </radialGradient>
                          <radialGradient id="paint1_radial_1086_570561" cx="0" cy="0" r="1"
                            gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(24 -8.3) rotate(90) scale(24.65)">
                            <stop stop-color="#8BD6EF" />
                            <stop offset="1" stop-color="#8BD6EF" stop-opacity="0" />
                          </radialGradient>
                          <radialGradient id="paint2_radial_1086_570561" cx="0" cy="0" r="1"
                            gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(24 -8.3) rotate(90) scale(24.65)">
                            <stop stop-color="#8BD6EF" />
                            <stop offset="1" stop-color="#8BD6EF" stop-opacity="0" />
                          </radialGradient>
                          <clipPath id="clip0_1086_570561">
                            <rect width="48" height="48" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <h4 class="mb-4 mt-1">Price visibility control</h4>
                    <p>Hide pricing for specific Groups when ordering is managed or approved.
                      Remove prices and control checkout based on your ordering policy.
                    </p>
                  </div>
                </ng-container>
              </div>
            </div>

          </div>
        </div>
        <div class="col-12 col-lg-6 col-xl-7">
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade ps-lg-5" id="pills-price-Visibility" role="tabpanel"
              aria-labelledby="pills-price-Visibility-tab" tabindex="0">
              <img src="../../../../assets/images/group-2.png" alt="group" class="ms-lg-5 w-100" style="max-width: 740px;" />
            </div>
            <div class="tab-pane fade ps-lg-5 show active" id="pills-tailored-product" role="tabpanel"
              aria-labelledby="pills-tailored-product-tab" tabindex="0">
              <!-- <img src="../../../../assets/images/group-1.png" alt="group" class="ms-lg-5" style="max-width: 740px;"/> -->
              <video autoplay loop muted class="w-100">
                <source src="../../../../assets/images/group-animation.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
            <div class="tab-pane fade ps-lg-5" id="pills-seamless" role="tabpanel" aria-labelledby="pills-seamless-tab"
              tabindex="0">
              <img src="../../../../assets/images/group-3.png" alt="group" class="ms-lg-5 w-100" style="max-width: 740px;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ============================ -->
<!-- Why Use Groups section end here... -->
<!-- ============================ -->

<!-- ========================================= -->
<!-- Ready to Ask section start here... -->
<!-- ========================================= -->
<section class="freq-ask">
  <div class="max-width-container">
    <div class="container">
      <div class="get-touch">
        <div class="d-flex align-items-center justify-content-center flex-column text-center py-5 my-5">
          <h3 class="fw-semibold mb-3 lh-sm">
            Ready to set uniform rules by role, site, or project?
          </h3>
          <p class="mb-5 pb-3">
            Set Group-based access, entitlements, and price visibility in one place. We will
            <br class="d-none d-lg-block" />
            help you configure it for your workforce.
          </p>
          <button class="btn btn-primary px-md-5" type="button" routerLink="/contactus">Book a demo</button>
          <h5 class="mt-4">
            Quick walkthrough. No obligation.
          </h5>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ========================================= -->
<!-- Ready to Ask section end here... -->
<!-- ========================================= -->